module.exports = __webpack_public_path__ + "img/image20.72370973.jpg";